export default "__VITE_PUBLIC_ASSET__27067bf1__"